import { Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import styles from '../Intimidad/Intimidad.module.css';

export const HaveReportPDF = ({ haveReportPDF, handleHaveReportPDF }) => {
  return (
    <div className={styles.intimidad}>
      <div className={styles.top}>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', marginBottom: '15px' }}
        >
          La encuesta tiene reporte PDF, Power Point o Word?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Al marcar esta opción llegará un reporte, al correo en formato(PDF, Power Point o word)
        </Typography>
      </div>
      <div className={styles.bottom}>
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={haveReportPDF}
                onChange={(e) => handleHaveReportPDF(e.target.checked)}
              />
            }
            label={
              haveReportPDF
                ? 'Sí Generar documento.'
                : 'No generar documento.'
            }
          />
        </FormControl>
      </div>
    </div>
  );
};
